export default __webpack_public_path__ + "static/media/attention1.3bccdbb9.mp3";